import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from "react-intl";
import Slider from "react-slick";
import * as routes from "../constants/routes";
import "../theme/howItWorks.css";
import WashPackagePrices from "./WashPackagePrices";
import AppStoreLink from "./AppStoreLink";
import CompetitiveLink from "./CompetitiveLink";

class DetailerHowItWorks extends Component {
  static propTypes = {
    intl: PropTypes.shape({}).isRequired
  };

  translateMessage = messageID => {
    const { intl } = this.props;
    return intl.formatMessage({ id: messageID });
  };

  render() {
    const sliderSettings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 30000,
      initialSlide: 0
    };

    const componentName = "DetailerHowItWorks";
    let tileID = 1;
    const tilesJSON = [
      {
        id: tileID++,
        cssOverride: "tileLeft",
        image: require("../images/home/signup.jpg"),
        imageAltID: "SignUpTitle",
        titleID: "SignUpTitle",
        contentID: "SignUpContent",
        contentParams: { SIGNUP_LINK: routes.DETAILER_SIGNUP }
      },
      {
        id: tileID++,
        image: require("../images/detailer/stripe_customers.jpg"),
        imageAltID: "SetupBankingTitle",
        titleID: "SetupBankingTitle",
        contentID: "SetupBankingContent",
        contentParams: {
          STRIPE_LINK: routes.STRIPE_WEBSITE,
          STRIPE_ABOUT_LINK: routes.STRIPE_WEBSITE_ABOUT
        }
      },
      {
        id: tileID++,
        cssOverride: "tileLeft",
        image: require("../images/detailer/home.jpg"),
        imageAltID: "InstallAppTitle",
        titleID: "InstallAppTitle",
        contentID: "InstallAppContent",
        additionalContent: <AppStoreLink />
      },
      {
        id: tileID++,
        image: require("../images/detailer/availability.jpg"),
        imageAltID: "DefineAvailabilityTitle",
        titleID: "DefineAvailabilityTitle",
        contentID: "DefineAvailabilityContent"
      },
      {
        id: tileID++,
        cssOverride: "tileLeft",
        image: require("../images/home/package_selection.jpg"),
        imageAltID: "FairPricingTitle",
        titleID: "FairPricingTitle",
        contentID: "FairPricingContent",
        additionalContent: (
          <div>
            <WashPackagePrices />
            <CompetitiveLink />
          </div>
        )
      },
      {
        id: tileID++,
        image: require("../images/home/package_selection.jpg"),
        imageAltID: "AcceptOrdersTitle",
        titleID: "AcceptOrdersTitle",
        contentID: "AcceptOrdersContent"
      },
      {
        id: tileID++,
        image: require("../images/detailer/chat.jpg"),
        imageAltID: "ChatCustomerTitle",
        titleID: "ChatCustomerTitle",
        contentID: "ChatCustomerContent"
      },
      {
        id: tileID++,
        cssOverride: "tileLeft",
        image: require("../images/detailer/traveling.jpg"),
        imageAltID: "ProtectFraudTitle",
        titleID: "ProtectFraudTitle",
        contentID: "ProtectFraudContent"
      },
      {
        id: tileID++,
        image: require("../images/detailer/accounting.jpg"),
        imageAltID: "GettingPaidTitle",
        titleID: "GettingPaidTitle",
        contentID: "GettingPaidContent"
      }
    ];

    return (
      <div>
        <h1>
          <FormattedMessage id={`${componentName}.Title`} />
        </h1>
        <Slider {...sliderSettings}>
          {tilesJSON.map(tile => {
            const {
              id,
              cssOverride,
              image,
              imageAltID,
              titleID,
              contentID,
              contentParams,
              additionalContent
            } = tile;

            return (
              <div key={id} id={`tile${id}`} className={`tile ${cssOverride}`}>
                <img
                  alt={this.translateMessage(`${componentName}.${imageAltID}`)}
                  className="screenshot"
                  src={image}
                />
                <div className="copy">
                  <h2>
                    <FormattedMessage id={`${componentName}.${titleID}`} />
                  </h2>
                  <FormattedHTMLMessage
                    id={`${componentName}.${contentID}`}
                    values={contentParams}
                  />
                  {additionalContent ? additionalContent : null}
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    );
  }
}

export default injectIntl(DetailerHowItWorks);



// WEBPACK FOOTER //
// ./src/components/DetailerHowItWorks.js